// extracted by mini-css-extract-plugin
export default {"coreValuesContainer":"CoreValues_coreValuesContainer__-ABnj"};